













import i18n from '@/i18n'
import { mapState, mapMutations, mapGetters } from 'vuex'
import { GetFileInfoByFileId, getUserInfo, getCompanyService } from '@/services/api'
import ErrorPage from '@/components/ErrorPage'
import LoadingPage from '@/components/LoadingPage'
import { TopBarDefault, NewTopBar } from '@/components/TopBar'
import ForbidPage, { useForbidPage } from '@/components/ForbidPage'
import TopTips from '@/components/TopTips'
import { ContactDialog } from '@/components/Dialog'
import getError from '@/utils/error.js'
import Emitter from 'element-ui/lib/mixins/emitter'
import { getCurrentInstance } from '@vue/composition-api'
import { errorCodeMap } from '@/utils/errorcodes.js'
export default {
  name: 'App',
  componentName: 'APP',
  components: {
    LoadingPage,
    NewTopBar,
    TopBarDefault,
    ForbidPage,
    ErrorPage,
    ContactDialog,
    TopTips
  },
  mixins: [Emitter],
  computed: {
    ...mapGetters(['isCompanyAuth']),
    ...mapState(['fileInfo', 'fileType', 'userInfo', 'userSelf']),
    showNewTopBar(this: any) {
      return this.forbidPage.showNewTopBar && this.fileInfo && !this.checkfailed.includes(this.errorCode)
    },
    showTopBarDefault(this: any) {
      return !this.showNewTopBar && (this.forbidPage.showTopBarDefault || this.checkfailed.includes(this.errorCode))
    },
    showLoading(this: any) {
      return this.forbidPage.showLoading && this.loading
    },
    showErrorPage(this: any) {
      return this.forbidPage.showErrorPage && !this.loading && this.error
    },
    showRouterView(this: any) {
      return this.forbidPage.showEntryRouter && !this.showErrorPage
    }
  },
  setup(props, context) {
    const vm = getCurrentInstance() as any
    const handleXhrError = (e) => {
      const { result, code } = e?.response?.data || {}
      const msg =
        result === 'permissionDenied'
          ? getError(result)
          : vm?.proxy?.getErrorMsg?.({
            result,
            code
          })
      if (msg) {
        vm?.proxy?.$message?.error(msg)
      }
    }
    const forbidPage = useForbidPage({
      handleXhrError,
      listeners: {
        error: handleXhrError
      },
      props: {
        fileId: vm?.proxy?.$route?.params?.fileId,
        sId: vm?.proxy?.$route?.params?.sid
      }
    })
    return {
      forbidPage
    }
  },
  data() {
    return {
      msg: i18n.t('8bd57619ed'),
      errorCode: '',
      errorInfo: null,
      error: false,
      loading: true,
      isLogin: true,
      checkfailed: [errorCodeMap.AUTH_CHECK_FAILED, errorCodeMap.FILENAME_CHECK_FAILED],
      reportFn: null
    }
  },
  async created() {
    this.$on('set_loading_status', (status) => {
      this.loading = status
    })
    this.$on('showError', (error) => {
      this.getErrorMsg(error.info, error.val)
    })
    this.$on('dwReporter', (params) => {
      this.dwReporter(params)
    })
    try {
      let res = await getUserInfo()
      // 一般情况下都是sid，之前接口出过问题导致会出现fileid情况，需要兼容
      this.$kmon.setKmonConfig({ userid: res.userid, fileid: this.$route.params.sid || this.$route.params.fileId })
      this.SET_USER_INFO(res)
      if (res.companyid) {
        let { info } = await getCompanyService(res.companyid)
        if (info[0]){
          this.SET_USER_SELF(info[0])
        }
      }
    } catch ({ response = {} }) {
      // 分享链接无需处理check的异常
      if (!this.$route.params.sid && typeof response === 'object') {
        this.getErrorMsg(response.data)
      }
    }
  },
  mounted() {
    window.addEventListener('beforeunload', (this.reportFn = () => {
      this.$DwManager.reportPlayAction(this.fileInfo)
      window.removeEventListener('beforeunload', this.reportFn)
    }))
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.reportFn)
  },
  methods: {
    ...mapMutations(['SET_USER_INFO', 'SET_USER_SELF']),
    getErrorMsg(this: any, errorInfo: any = {}, errorVal) {
      try {
        let code: any = errorInfo.code || errorInfo.result
        // 如果判断为没有登录，不再进行后续的判断
        if (!this.isLogin) {
          return
        }
        this.isLogin = ![
          errorCodeMap.NOT_LOGIN,
          errorCodeMap.NOT_LOGIN_STR
        ].includes(code)
        // 如果服务端返回了msg，则直接使用
        const msg = (errorInfo.requestType === 'preview' && errorInfo.code === 50010023 && errorInfo?.msg) ? errorInfo?.msg : getError(code, errorVal)
        const isMember = this.userSelf.roles === 'member'
        if (msg) {
          this.msg = ['lightlinkForbid', ...this.checkfailed].includes(code) ? '' : msg
        } else if (code) {
          // 服务错误
          this.msg = i18n.t('a0f065de59')
        }
        // 后面有空全面处理错误异常
        if (code === 'permissionDenied') {
          this.msg = i18n.t('6c9f11f229', [this.userInfo.nickname])
        } else if (code === errorCodeMap.COMMPANY_PACKAGE_FAILED) {
          this.msg = i18n.t('cdc5268c10')
        } else if (code === errorCodeMap.NOT_COMPANY_CHECK_FAILED) {
          this.msg = i18n.t('22f2a07b81')
        } else if (code === errorCodeMap.COMPANY_NOT_CERTIFY) {
          this.msg = isMember ? i18n.t('1cd5c90386') : i18n.t('a04123abbc')
        }
        this.errorCode = code
        this.errorInfo = errorInfo
        this.error = true
        this.dwReporter({
          page: 'unpreview',
          operation: 'show',
          error_code: code
        })
      } catch (err) { }
      this.$DwManager.recordConvertStatus(this.msg)
      return this.msg
    },
    getSuccess(this: any) {
      this.error = false
    },
    dwReporter(params) {
      let defaultParmas = {
        company_id: this.userInfo.companyid,
        user_id: this.userInfo.userid,
        role: this.userSelf.roles,
        client: 'web',
        fileid: this.fileInfo.fileid,
        filetype: this.fileInfo.fname.split('.').reverse()[0].toLowerCase(),
        certification_status: this.isCompanyAuth
      }
      this.$report.report('preview_video', {
        ...defaultParmas,
        ...params
      })
    },
    contactUs() {
      this.$refs.contact.show()
    }
  },
  watch: {
    '$route.name': {
      async handler(newVal) {
        const { params, query } = this.$route
        // 进入p链接时重定向到l链接
        if (newVal === 'pEntry') {
          try {
            // ! NOTE: use GetFileInfoByFileId as alternative to getLinkInfoByFid,
            // because link_id is empty array using getLinkInfoByFid when the file is in the share folder and you open it from the kdocs home page
            const { fileinfo: { link_id: linkId } } = await GetFileInfoByFileId(params.fileId)
            if (linkId) {
              this.$router.replace({
                name: 'lEntry',
                params: {
                  sid: linkId
                },
                query
              })
            }
          } catch (e) { }
        }
      },
      immediate: true
    }
  }
} as any
